<template>
<div class="page_transport">
  <div class="container py-5">
    <div class="page_topic_blcok my-4">
      <div class="topic_border">
        <p class="topic_eng">NEWS</p>
        <p class="topic_cht">最新消息</p>
      </div>
    </div>
    <!-- 最新消息 -->
    <div class="member_title">
      <!--<h2>
        <img src="@/assets/icons/member_title.png" /> 最新消息
      </h2>-->
    </div>
    <div class="member_news_table">
      <table>
        <tr>
          <th>發布時間</th>
          <th colspan="2">主旨</th>
        </tr>
        <tr>
          <td>2018-11-08</td>
          <td>逗陣享受美味蔬食11/30-12/03高雄展覽館 品牌BUFFET餐券免費送</td>
          <td></td>
        </tr>
        <tr>
          <td>2018-11-08</td>
          <td>倒數3天！提醒您記得領取►孕媽咪福袋、搬搬樂/爬行賽/搬尿布大賽免費報名◄孕嬰用品3折起！11/30-12/3婦幼品牌特賣會</td>
          <td></td>
        </tr>
        <tr>
          <td>2018-11-02</td>
          <td>台北貓展『免費門票』最後100張！送完就沒了！</td>
          <td></td>
        </tr>
        <tr>
          <td>2018-11-01</td>
          <td>高雄運動展 搶500張【0元門票】拿10萬購物金、1200福袋0元搶， 11/30-12/3高雄展覽館</td>
          <td></td>
        </tr>
        <tr>
          <td>2018-10-25</td>
          <td>【奉茶　舌尖上的一期一會】高雄茶展 11/30-12/03高雄展覽館</td>
          <td></td>
        </tr>
        <tr>
          <td>2018-10-22</td>
          <td>12/14-17台中旅展搶【免費門票】再加碼抽『惠而浦微波爐』！年終最後一檔旅遊盛會，祭出眾多限時限量優惠商品！</td>
          <td></td>
        </tr>
        <tr>
          <td>2018-10-22</td>
          <td>★年終大回饋★11/30-12/3新北最大規模婦幼品牌特賣會【免費索票】尿布/奶瓶/推車全面3折起！</td>
          <td></td>
        </tr>
      </table>
    </div>
    <div class="member_news_pagination">
      <ul>
        <li class="active">1</li>
        <li>2</li>
        <li>3</li>
        <li>4</li>
        <li>5</li>
      </ul>
    </div>

    <!--報名參展紀錄-->
    <div class="page_topic_blcok my-4">
      <div class="topic_border">
        <p class="topic_eng">RECORDS</p>
        <p class="topic_cht">報名參展紀錄</p>
      </div>
    </div>
    <div class="member_title">
      <!--<h2>
        <img src="@/assets/icons/member_title.png" /> 報名參展紀錄
      </h2>-->
    </div>
    <div class="member_record_block">
      <p>
        <ul>
          <li>※ 大會將會以此報名表資訊作為審核的依據，<span style="color:red;">請詳細填寫下方報名表單</span>；系統收到您的申請資訊後將會發送「<span style="color:red;">參展資訊登錄成功信</span>」至<span style="color:red;">承辦人E-mail</span>中，請確認系統信中所示的<span style="color:red;">廠商資訊&amp;參展資訊</span>正確無誤。</li>
          <li>※ 若您要查詢您的報名紀錄，請選擇「<span style="color:red;">報名參展記錄</span>」查詢您的所有報名紀錄及進度。</li>
          <li>※ 若您有任何問題請洽詢您的責任業務，或與客服人員聯絡：電話：02-2759-7167、E-mail：CRM@top-link.com.tw。</li>
        </ul>
      </p>
      <div class="member_record_table">
        <table>
          <tr>
            <th>展覽名稱</th>
            <th>展覽時間&amp;地點</th>
            <th>展區分類</th>
            <th>承租攤位</th>
            <th>報名時間</th>
            <th>報名進度</th>
            <th style="width:100px;"></th>
          </tr>
          <tr>
            <td>嬰兒與孕媽咪用品展</td>
            <td>2017.09.02~05 台中朝馬展覽館</td>
            <td>A.XXXX區</td>
            <td>標準攤位2格</td>
            <td>2016-12-13 16:20:57</td>
            <td>初審：已通過<br>繳款：請款中<br>複審：尚未進入複審</td>
            <td><router-link :to="{name: 'print_fee'}"><img src="@/assets/icons/print_btn.png" /></router-link></td>
          </tr>
          <tr>
            <td>嬰兒與孕媽咪用品展</td>
            <td>2017.10.07~10 台北世貿一館</td>
            <td>A.XXXX區</td>
            <td>標準攤位2格</td>
            <td>2016-11-10 16:20:57</td>
            <td>初審：已通過<br>繳款：請款中<br>複審：尚未進入複審</td>
            <td><router-link :to="{name: 'print_nofee'}"><img src="@/assets/icons/print_btn.png" /></router-link></td>
          </tr>
        </table>
      </div>
    </div>

  </div>  
</div>



</template>

<script>
export default {
  data () {
    return{};
  }
}
</script>

<style>
.member_title>h2 {
  border-bottom:3px solid rgb(10, 116, 0);
  padding:4px 0;
}

/* 最新消息CSS */
.member_news_table {
  overflow:auto;
}
.member_news_table table {
  width:1100px;
  margin:20px auto;
}
.member_news_table tr {
  border-bottom:1px solid #d8d8d8;
}
.member_news_table tr:first-child {
  color:white;
  background:#155498;
  letter-spacing:3px;
  text-align:center;
}
.member_news_table tr:first-child th {
  border-right:1px solid white;
  padding:5px 0;
  font-size:1.1rem;
}
.member_news_table td:first-child {
  width:149px;
  padding:10px 30px;
}
.member_news_table td:nth-child(2) {
  padding:10px 0 10px 10px;
  letter-spacing:1px;
}
.member_news_table td:nth-child(3) {
  width:100px;
}

.member_news_pagination ul {
  list-style-type:none;
  margin:0;
  padding:0;
  text-align:center;
}
.member_news_pagination ul li {
  display:inline-block;
  cursor:pointer;
  padding:5px 10px;
  border:1px solid #a2a2a2;
}
.member_news_pagination ul li.active {
  color:white;
  background:#155498;
}
.member_news_pagination ul li:not(.active):hover {
  background:#81bdff;
}


/* 報名參展紀錄CSS */
.member_record_block>p {
  max-width:900px;
  margin:auto;
}
.member_record_block>p>ul {
  list-style-type:none;
  margin:20px auto;
  padding:0;
  font-size:15px;
}
.member_record_block>p>ul>li {
  line-height:1.6;
}

.member_record_table {
  overflow:auto;
  margin:25px auto;
}
.member_record_table table {
  width:1100px;
  margin:25px auto;
}

.member_record_table th,
.member_record_table td {
  border:1.5px solid #797979;
}
.member_record_table th {
  padding:15px;
  text-align:center;
  color:white;
  background:#666666;
  font-size:18px;
  letter-spacing:1.5px;
}
.member_record_table td {
  padding:10px;
  font-size:16px;
}
.member_record_table td:last-child {
  text-align:center;
}

/**page_topic**/
.page_topic_blcok { 
  display:inline-block; 
  text-align: right;
}
.page_topic_blcok .topic_border { 
  padding: 0px 1rem 1px 0;
  border-right:1px solid #d6d6d6; 
  font-size:2rem; 
  line-height:1.1;
}
.page_topic_blcok .topic_border .topic_eng { 
  color:#8c8c8d;
  line-height:1.5;
  margin:0;
}
.page_topic_blcok .topic_border .topic_cht { 
  color:#b0b0b0;
  line-height:1.5;
  letter-spacing:9px;
  margin-right:-9px; 
}

</style>



// WEBPACK FOOTER //
// src/components/pages/signup_record.vue